<ion-content>
  <div class="bg"></div>
  <div class="full-height two-thirds-width">
    <div class="lov wrap center h-sa p full-height">
      <div class="m pxx container front round size-adjustment">
        <div class="preamble lov h-center p m">
          <ion-img
            [class]="section != 'confirmEmail' ? 'logo-login' : 'logo-login-min'"
            src="/assets/images/logo-portal.png"
            alt="Grupo Jacto - logo do grupo jacto">
          </ion-img>
        </div>

        <section [hidden]="section !== 'login'" class="max-width-login">
          <strong><span translate class="span-login">login.label.infos </span></strong>

          <form #f1="ngForm" class="mt">
            <ion-list lines="none" class="ion-no-padding">
              <ion-item class="border center">
                <ion-label position="floating" translate>common.personalNumber</ion-label>
                <ion-input
                  type="text"
                  name="user"
                  [(ngModel)]="userLogin"
                  required
                  (ionChange)="adLogin = true"
                  (keyup.enter)="f1.valid ? verifyEmail() : null"></ion-input>
              </ion-item>

              <ion-item class="border center">
                <ion-label position="floating" translate>login.input.password</ion-label>

                <ion-input
                  name="password"
                  [(ngModel)]="password"
                  required
                  [type]="showPassword ? 'text' : 'password'"
                  (keyup.enter)="f1.valid && password ? validateLogin() : null">
                </ion-input>

                <ion-icon
                  (click)="showPassword = !showPassword"
                  [name]="showPassword ? 'eye-off' : 'eye'"
                  slot="end"
                  size="small"></ion-icon>
              </ion-item>
              <!-- <ion-button
								class="j-button"
								*ngIf="btnEnabled && adLogin"
								expand="block"
								[disabled]="!f1.valid"
								type="submit" 
								translate
								(click)="verifyEmail()"
								>common.continue
							</ion-button> -->

              <ion-button
                class="j-button"
                *ngIf="btnEnabled"
                expand="block"
                [disabled]="!f1.valid"
                type="submit"
                translate
                (click)="validateLogin()"
                >common.enter
              </ion-button>

              <ion-button class="j-button" *ngIf="!btnEnabled" expand="block">
                <ion-spinner name="crescent"></ion-spinner>
              </ion-button>

              <ion-button
                routerLink="/register/retired-employee"
                class="j-button outline bold"
                expand="block"
                type="button"
                fill="outline"
                translate>
                login.register.retiredEmployee
              </ion-button>

              <!-- <div class="lov h-right">
								<ion-button  (click)="section = 'recovery'" fill="clear" size="small" class="p0"
									translate>login.button.recoverPassword</ion-button>
							</div> -->

              <div class="separator-row">
                <div class="line"></div>
                <span class="text" translate>sso.other</span>
                <div class="line"></div>
              </div>

              <ion-button class="j-button outline bold sso-btn" expand="block" type="button" fill="outline" (click)="loginSSO()">
                <ion-icon name="key-outline"></ion-icon>
                <span translate>sso.login</span>
              </ion-button>
              <div>
                <ion-row class="pv">
                  <ion-col size="12" sizeMd="6">
                    <a href="https://www.grupojacto.com.br/politica-privacidade" target="_blank" translate class="policies tc">
                      common.privacy
                    </a>
                  </ion-col>
                  <ion-col size="12" sizeMd="6">
                    <a href="https://www.grupojacto.com.br/politica-privacidade-cookie" target="_blank" translate class="policies tc">
                      common.cookies
                    </a>
                  </ion-col>
                  <!-- ativar somente quando tiver o Aviso Legal e mudar o size dos cols -->
                  <!-- <ion-col size="4">
										<a
											class="app m"
											href="https://www.grupojacto.com.br/politica-privacidade-cookie"
											target="_blank"
										>
											Aviso Legal
										</a>
									</ion-col> -->
                </ion-row>
                <ion-row class="flex-center">
                  <ion-col class="button-col" size="6">
                    <a routerLink="/faq" routerDirection="root" translate target="_blank" class="policies tc"> login.faq </a>
                  </ion-col>
                </ion-row>
              </div>
            </ion-list>
          </form>
        </section>

        <section [hidden]="section !== 'recovery'">
          <form #f2="ngForm" (ngSubmit)="recovery()">
            <ion-list lines="none" class="ion-no-padding">
              <ion-item class="border center">
                <ion-label position="floating" translate>common.email</ion-label>
                <ion-input type="text" name="user" [(ngModel)]="email" required class="min-input"></ion-input>
              </ion-item>

              <ion-button
                (click)="recovery()"
                [hidden]="recoveryPassword"
                class="j-button"
                *ngIf="btnEnabled"
                expand="block"
                [disabled]="!f2.valid"
                type="submit"
                translate
                >common.continue</ion-button
              >

              <ion-button class="j-button" *ngIf="!btnEnabled" expand="block">
                <ion-spinner name="crescent"></ion-spinner>
              </ion-button>
              <div>
                <ion-button (click)="section = 'login'" fill="clear" size="small" class="p0" translate>login.button.return</ion-button>
              </div>
            </ion-list>
          </form>
        </section>

        <section [hidden]="section !== 'reset'" *ngIf="changePass">
          <form #f3="ngForm" (ngSubmit)="resetPassword()">
            <ion-list lines="none" class="ion-no-padding">
              <ion-item class="border center">
                <ion-label position="floating" translate>common.personalNumber</ion-label>

                <ion-input type="text" name="user" [(ngModel)]="userLogin" required></ion-input>
              </ion-item>

              <ion-item class="border center">
                <ion-label position="floating" translate>common.newPassword</ion-label>
                <ion-input
                  name="newPassword"
                  [(ngModel)]="new_password"
                  required
                  (ionChange)="checkPassword()"
                  [type]="showPassword ? 'text' : 'password'"
                  clear-on-edit="false">
                </ion-input>

                <ion-icon
                  (click)="showPassword = !showPassword"
                  [name]="showPassword ? 'eye-off' : 'eye'"
                  slot="end"
                  size="small"></ion-icon>
              </ion-item>

              <div class="full-width error-area">
                <ion-row class="flex-center full-width">
                  <ion-col class="ion-no-padding">
                    <ion-label [color]="uppercase ? 'success' : 'danger'" class="error-input" translate> login.error.uppercase </ion-label>
                  </ion-col>
                  <ion-col class="ion-no-padding">
                    <ion-label [color]="characterSpecial ? 'success' : 'danger'" class="error-input" translate>
                      login.error.characterSpecial
                    </ion-label>
                  </ion-col>
                </ion-row>

                <ion-row class="flex-center full-width">
                  <ion-col class="ion-no-padding">
                    <ion-label [color]="characterNumbers ? 'success' : 'danger'" class="error-input" translate>
                      login.error.characterNumbers
                    </ion-label>
                  </ion-col>
                  <ion-col class="ion-no-padding">
                    <ion-label [color]="passLength ? 'success' : 'danger'" class="error-input" translate> login.error.minLength </ion-label>
                  </ion-col>
                </ion-row>
              </div>

              <ion-item class="border center">
                <ion-label position="floating" translate>login.input.confirmPassword</ion-label>
                <ion-input
                  name="repeatPassword"
                  [(ngModel)]="validate_password"
                  required
                  [type]="showRepeatPassword ? 'text' : 'password'"
                  clear-on-edit="false"
                  (keyup.enter)="f3.valid && new_password === validate_password ? resetPassword() : null">
                </ion-input>

                <ion-icon
                  (click)="showRepeatPassword = !showRepeatPassword"
                  [name]="showRepeatPassword ? 'eye-off' : 'eye'"
                  slot="end"
                  size="small"></ion-icon>
              </ion-item>
              <label *ngIf="new_password !== validate_password" class="error-input" translate> common.diffPassword </label>

              <div *ngIf="firstLogin">
                <span translate class="span-login block">login.input.emailInfos</span>
                <ion-item class="border center">
                  <ion-label position="floating" translate>common.email</ion-label>
                  <ion-input name="FirstEmail" [(ngModel)]="firstLoginEmail" required type="text" (ionChange)="checkEmail()"> </ion-input>
                </ion-item>
              </div>

              <ion-button
                class="j-button"
                *ngIf="btnEnabled && firstLogin"
                expand="block"
                [disabled]="
                  (!f3.valid && !uppercase) ||
                  !passLength ||
                  !characterSpecial ||
                  !characterNumbers ||
                  !firstLoginEmail ||
                  new_password !== validate_password ||
                  !validEmail
                "
                type="submit"
                translate
                >common.continue
              </ion-button>

              <ion-button
                class="j-button"
                *ngIf="btnEnabled && !firstLogin"
                expand="block"
                [disabled]="
                  (!f3.valid && !uppercase) || !passLength || !characterSpecial || !characterNumbers || new_password !== validate_password
                "
                type="submit"
                translate
                >common.continue
              </ion-button>
              <ion-button class="j-button" *ngIf="!btnEnabled" expand="block">
                <ion-spinner name="crescent"></ion-spinner>
              </ion-button>
            </ion-list>
          </form>
        </section>

        <section *ngIf="section === 'newSession'" class="max-width-login">
          <form #f3="ngForm" class="mt" (ngSubmit)="validateLogin()">
            <ion-list lines="none" class="ion-no-padding">
              <ion-label position="floating" translate class="already-logged-label">login.alreadLogged</ion-label>
              <ion-button class="j-button margin-new-session" *ngIf="btnEnabled" expand="block" type="submit" translate
                >login.button.continueNewSession</ion-button
              >
              <ion-button class="j-button" *ngIf="!btnEnabled" expand="block">
                <ion-spinner name="crescent"></ion-spinner>
              </ion-button>
              <div>
                <ion-button (click)="section = 'login'" fill="clear" size="small" class="p0" translate>login.button.return</ion-button>
              </div>
            </ion-list>
          </form>
        </section>

        <section *ngIf="section === 'confirmEmail'" class="flex-center column-flex">
          <ion-item class="flex-center">
            <ion-label class="confirm-email-label" translate>
              {{ emailConfirmed ? 'Estamos validando seu e-mail' : 'Seu e-mail foi validado com sucesso!' }}
            </ion-label>
            <ion-spinner *ngIf="!emailConfirmed" name="dots"></ion-spinner>
          </ion-item>

          <ion-spinner *ngIf="!emailConfirmed" name="crescent" class="mt"></ion-spinner>

          <div *ngIf="emailConfirmed">
            <ion-button (click)="section = 'login'" fill="clear" size="small" class="p0" translate routerLink="/login"
              >login.button.return</ion-button
            >
          </div>
        </section>

        <div class="ion-text-center mt">
          <label class="dev-label">{{ appVersion }}</label>
        </div>
      </div>
    </div>
  </div>
  <app-notification-badge></app-notification-badge>
</ion-content>
